//
//
//
//
//
//
//
//


export default{
 
  data(){
    return{
      name:'',

      paths:[]
    }
  },
  mounted(){
   
  },
  methods:{

  }
}



// WEBPACK FOOTER //
// ./src/views/Shouye.vue